module.exports = __webpack_public_path__ + "static/media/6.8a17da78.jpg";